<template>
  <div class="bannerbox">
    <div class="par-pos">
            <vue-particles
              color="#ffffff"
              :particleOpacity="0.7"
              linesColor="#ffffff"
              :particlesNumber="80"
              shapeType="circle"
              :particleSize="5"
              :linesWidth="2"
              :lineLinked="true"
              :lineOpacity="0.4"
              :linesDistance="150"
              :moveSpeed="3"
              :hoverEffect="true" 
              :clickEffect="true"
              clickMode="push"
            >
            </vue-particles>
          </div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="item item-fff">
       
          <div class="cont">
            <div class="wrap">
              <div class="tit translateY">
                聊一聊 AI助力找工作
              </div>
              <div class="text translateY">
                <p>
                  求职新体验，科技校招，一键找寻最适合你的工作
                </p>
              </div>
              <div class="btn translateY" style="background-color: red;"><a href="/#/aiRecommendation"><span>查看详情</span></a></div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="item item-fff">
          <div class="cont">
            <div class="wrap">
              <div class="tit translateY">
                择业直通车
              </div>
              <div class="text translateY">
                <p>
                  资深求职顾问，目标化助你入职
                </p>
              </div>
              <div class="btn translateY" style="background-color: red;"><a href="/#/consultant"><span>查看详情</span></a></div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="item item-fff">
          <div class="cont">
            <div class="wrap">
              <div class="tit translateY">
                近期新闻
              </div>
              <div class="text translateY">
                <p>
                  关注公众号获取实时最新动态
                </p>
              </div>
              <a href="/#/News"><div class="btn translateY" style="background-color: red;"><span>查看详情</span></div></a>
            </div>
          </div>
        </div>
      </swiper-slide>
      
      <div class="swiper-pagination bannerbox-page" slot="pagination"></div>
    </swiper>
    <div class="list">
      <ul class="wrap">
        <li>
          <a href="/#/aiRecommendation" class="li">
            <div class="bg"></div>
            <div class="flex1">
              <h3>AI求职</h3>
              <p style="font-size: 14px;">科技校招，告别内卷</p>
            </div>
            <img class="img" src="../assets/img/pinceimgfa1.png" />
          </a>
        </li>
        <li>
          <a href="/#/consultant" class="li">
            <div class="bg"></div>
            <div class="flex1">
              <h3>择业咨询</h3>
              <p style="font-size: 14px;">量身定制个性化求职解决方案</p>
            </div>
            <img class="img" src="../assets/img/pinceimgfa2.png" />
          </a>
        </li>
        <li>
          <a href="#" class="li">
            <div class="bg"></div>
            <div class="flex1">
              <h3>公务考察整体解决方案</h3>
              <p></p>
            </div>
            <img class="img" src="../assets/img/pinceimgfa3.png" />
          </a>
        </li>
        <li>
          <a href="#" class="li">
            <div class="bg"></div>
            <div class="flex1">
              <h3>中小学夏校</h3>
              <p></p>
            </div>
            <img class="img" src="../assets/img/pinceimgfa4.png" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//import Banner from "../components/Banner";

export default {
  data() {
    return {
      loading: false,
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
         effect: "fade",
        on: {
          slideChangeEnd: function() {
            //console.log(swiper.activeIndex);swiper
          },
        },
      },
    };
  },
  mounted() {},
  components: {
    // Banner
  },
  created() {},
};
</script> 
